export default "__VITE_ASSET__FQotdhyj__"